import { Banner } from "../components/Banner";
import { Projects } from "./Projects";
import { Photography } from "./Photography";
import { Contact } from "./Contact";
import { About } from "../components/about";
import {  Skills } from "../components/skills";
import { Experience } from "../components/experience";

export const Home = () => {
  return (
    <div className="home">
      <Banner />
      <Projects />
      {/* <Experience /> */}
      {/* <Skills /> */}
      {/* <Photography /> */}
      <Contact />
    </div>
  );
};
